import { z } from "zod";

import { ApiScopesList } from "./apis";

export const ApiAppsList = ["Amped", "CustomApi"] as const;
export type ApiAppsType = (typeof ApiAppsList)[number];

export const PutApiKeyDtoSchema = z.object({
  id: z.string().nullish(),
  name: z.string(),
  scopes: z.enum(ApiScopesList).array().nullish(),
  description: z.string().nullish(),
  action: z.enum(["new", "refresh", "delete"]),
});
export type PutApiKeyDto = z.infer<typeof PutApiKeyDtoSchema>;
